// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.consultant-form-container {
  background: url("https://images.unsplash.com/photo-1573497491208-6b1acb260507?auto=format&fit=crop&w=1600&q=80")
    no-repeat center center/cover;
  min-height: 100vh;
  padding: 3rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "IBM Plex Sans", sans-serif;
}

.consultant-form-container img.ace-logo {
  width: 160px;
  margin-bottom: 1rem;
}

.consultant-form-container h1 {
  font-size: 2rem;
  font-weight: 600;
  color: #1c1c1c;
  margin-bottom: 2rem;
  text-align: center;
}

.form-container {
  width: 100%;
  max-width: 960px;
  background-color: #ffffff;
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
}

/* Make iframe responsive */
.form-container iframe {
  width: 100%;
  border: none;
  border-radius: 4px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .consultant-form-container {
    padding: 2rem 1rem;
  }

  .consultant-form-container h1 {
    font-size: 1.5rem;
  }

  .form-container {
    padding: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ConsultantApply.css"],"names":[],"mappings":"AAAA;EACE;iCAC+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".consultant-form-container {\n  background: url(\"https://images.unsplash.com/photo-1573497491208-6b1acb260507?auto=format&fit=crop&w=1600&q=80\")\n    no-repeat center center/cover;\n  min-height: 100vh;\n  padding: 3rem 1rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-family: \"IBM Plex Sans\", sans-serif;\n}\n\n.consultant-form-container img.ace-logo {\n  width: 160px;\n  margin-bottom: 1rem;\n}\n\n.consultant-form-container h1 {\n  font-size: 2rem;\n  font-weight: 600;\n  color: #1c1c1c;\n  margin-bottom: 2rem;\n  text-align: center;\n}\n\n.form-container {\n  width: 100%;\n  max-width: 960px;\n  background-color: #ffffff;\n  padding: 1rem;\n  border-radius: 10px;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n/* Make iframe responsive */\n.form-container iframe {\n  width: 100%;\n  border: none;\n  border-radius: 4px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .consultant-form-container {\n    padding: 2rem 1rem;\n  }\n\n  .consultant-form-container h1 {\n    font-size: 1.5rem;\n  }\n\n  .form-container {\n    padding: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
